import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@lt/components';
import { useTranslation } from '@lt/localization';
import Icon from '../Icon';

const NameSwicther = ({ onSwitch, onClose }) => {
  const { t } = useTranslation();
  return (
    <div className="name-switcher">
      <div className="name-switcher__container">
        <div className="name-switcher__header">
          <div className="name-switcher__header--name">
            {t('checkout.touristForm.name.title')}
          </div>
          <Icon
            className="name-switcher__header--arrow"
            width={32}
            type="double-arrow"
          />
          <div className="name-switcher__header--name">
            {t('checkout.touristForm.surname.title')}
          </div>
        </div>
        <div className="name-switcher__content">
          {t('checkout.touristForm.switcher')}
        </div>
        <div>
          <Button size="tiny" primary onClick={onSwitch}>
            {t('checkout.touristForm.change')}
          </Button>
          <Button size="tiny" onClick={onClose}>
            {t('filters.panel.cancel')}
          </Button>
        </div>
      </div>
    </div>
  );
};

NameSwicther.propTypes = {
  onSwitch: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default NameSwicther;
